import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH4Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH4 extends Component<KuikaH4Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h4 className={classNames("kuika-typography-h4", className)} {...props}>
        {children}
      </h4>
    );
  }
}

export default KuikaH4;
